<template>
    <div class="shre--btn" style="display: inline-block;">
        <div class="float-right__">
            <button class="btn btn-primary" v-on:click="print"><i class="fa fa-print"></i></button>
            <button class="btn btn-success" v-on:click="emailTo"><i class="fa fa-envelope"></i></button>
            <button class="btn btn-danger" v-on:click="saveToFav"><i class="fa fa-heart"></i></button>
        </div>
        <!-- Email Modal -->
        <div id="emailModal" class="modal fade" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Email</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body table-responsive">
                        <form name="thisForm" method="post" @submit.prevent="validateBeforeSubmit">
                            <table class="table table-bordered">
                                <tbody>
                                    <tr>
                                        <td>
                                            <label>Recipient Name</label>
                                        </td>
                                        <td>
                                            <input type="text" v-model="recipient_name" name="recipient_name" class="form-control">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Recipient's Email <font color="red">*</font></label>
                                        </td>
                                        <td>
                                            <input type="text" v-model="recipient" v-validate="'required|email'"
                                                :class="{'form-control': true, 'is-invalid': errors.has('recipient') }"
                                                name="recipient" class="form-control">
                                            <small class="form-text text-danger" v-show="errors.has('recipient')">Please
                                                enter valid recipient.</small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Your Name</label>
                                        </td>
                                        <td>
                                            <input type="text" v-model="name" name="name" class="form-control">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <label>Your Email <font color="red">*</font></label>
                                        </td>
                                        <td>
                                            <input type="text" v-model="email" v-validate="'required|email'"
                                                :class="{'form-control': true, 'is-invalid': errors.has('email') }"
                                                name="email" class="form-control">
                                            <small class="form-text text-danger" v-show="errors.has('email')">Please
                                                enter valid email.</small>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td valign="top">
                                            <label>Comment</label>
                                        </td>
                                        <td>
                                            <textarea name="comment" class="form-control" v-model="comment"></textarea>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <vue-recaptcha :sitekey="recaptchaSitekey" @verify="onVerify" :loadRecaptchaScript="true" @expired="onExpiry" ref="recaptcha"></vue-recaptcha>
                                            <span class="text-danger" v-text="gRecaptchavalidation"></span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td>
                                            <input type="submit" class="btn btn-success" value="Send">
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import VueRecaptcha from 'vue-recaptcha';
    export default {
        components: {VueRecaptcha},
        data: function () {
            return {
                env: process.env.MIX_THEME,
                recipient_name: '',
                recipient: '',
                name: '',
                email: '',
                comment: '',
                gRecaptchaResponse: null,
                gRecaptchavalidation: null,
            }
        },
        methods: {
            onVerify(response) {
                this.gRecaptchaResponse = response;
            },
            onExpiry(){
                this.$refs.recaptcha.reset();
            },
            saveToFav() {
                console.log('Save To Fav');
                this.$swal.fire({
                    title: '<strong>Press <u>ctrl + D</u></strong>',
                    type: 'info',
                    html: 'You can add this page to your , ' +
                        'Bookmarks by pressing CTRL +D on your keyword.',
                    showCloseButton: true,
                    showCancelButton: true,
                    focusConfirm: false,
                    confirmButtonText: '<i class="fa fa-thumbs-up"></i> Great!',
                    confirmButtonAriaLabel: 'Thumbs up, great!',
                    cancelButtonText: '<i class="fa fa-thumbs-down"></i>',
                    cancelButtonAriaLabel: 'Thumbs down'
                })
            },
            print() {
                window.print();
            },
            emailTo() {
                $('#emailModal').modal('show');
            },
            validateBeforeSubmit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        let that = this;
                        axios.post(process.env.MIX_API_URL + '/email', {
                                recipient_name: that.recipient_name,
                                recipient: that.recipient,
                                name: that.name,
                                email: that.email,
                                comment: that.comment,
                                g_recaptcha_response: that.gRecaptchaResponse,
                                url: window.location.href,
                                session_id: that.session,
                            })
                            .then(function (response) {
                                $('#emailModal').modal('hide');
                                Vue.$toast.open({
                                    message: 'Email Sent Successfully',
                                    type: "success",
                                    duration: 5000,
                                    dismissible: true
                                })
                                // alert('Email send');
                            })
                            .catch(function (error) {
                                console.log(error);
                                if (error.response.data.errors.g_recaptcha_response) {
                                    that.gRecaptchavalidation = error.response.data.errors.g_recaptcha_response[0];
                                } else {
                                    that.gRecaptchavalidation = null;
                                }
                            });

                        return false;
                    }
                });
            }
        },
        computed: {
            url: function () {
                return process.env.MIX_API_URL;
            },
            baseUrl: function () {
                return window.location.href;
            },
            segment: function () {
                return window.location.href.substring(window.location.href.lastIndexOf('/') + 1)
            },
            recaptchaSitekey: function() {
                return process.env.MIX_GOOGLE_RECAPTCHA_KEY;
            }
        },
    }

</script>
